import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonButton
} from '@ionic/react';
import { Link } from 'react-router-dom';
import { Form, Formik } from 'formik';
import alerts from 'src/lib/alerts';
import app from 'src/feathers';
import yup from 'src/feathers/yup';
import Field from 'src/components/Field';

export default class PasswordForgot extends React.Component {
  schema = yup.object({
    email: yup.string().email().required().label('Email')
  });

  state = { success: null };

  handleSubmit = (data, formik) => {
    app
      .service('auth/password-forgot')
      .create(data)
      .then((resp) => {
        this.setState({ success: resp.message });
      })
      .catch((err) => {
        formik.setSubmitting(false);
        alerts.errors(err.message);
        if (err.errors) {
          formik.setErrors(err.errors);
        }
      });
  };

  render() {
    const { success } = this.state;
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Murphy</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid fixed style={{ height: '100%' }}>
            <IonRow className="align-items-center" style={{ height: '100%' }}>
              <IonCol sizeLg="4" offsetLg="4">
                {success ? (
                  <IonCard
                    bsStyle="success"
                    className="animated bounceIn faster mt-5"
                  >
                    <IonCardHeader>
                      <IonCardSubtitle>Success</IonCardSubtitle>
                      <IonCardTitle>Check your email</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                      <p>{success}</p>
                      <IonButton
                        className="ion-margin-top"
                        expand="block"
                        routerLink="/login"
                      >
                        Back to Login
                      </IonButton>
                    </IonCardContent>
                  </IonCard>
                ) : (
                  <IonCard>
                    <IonCardHeader>
                      <IonCardSubtitle>Reset Password</IonCardSubtitle>
                      <IonCardTitle>Come on back!</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                      <Formik
                        initialValues={{ email: '' }}
                        onSubmit={this.handleSubmit}
                        validationSchema={this.schema}
                        render={({ isSubmitting }) => {
                          return (
                            <Form>
                              <Field
                                type="email"
                                name="email"
                                label="Email"
                                disabled={isSubmitting}
                              />
                              <IonButton
                                type="submit"
                                color="primary"
                                expand="block"
                                className="ion-margin-bottom"
                                disabled={isSubmitting}
                              >
                                Send Email
                              </IonButton>
                              <Link to="/login" disabled={isSubmitting}>
                                Back to Login
                              </Link>
                            </Form>
                          );
                        }}
                      />
                    </IonCardContent>
                  </IonCard>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}
